import { Navigate } from 'react-router-dom';
import { Settings } from 'lucide-react';
import { Layout } from '@/components/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { DynamicsEnvironmentToggle } from '@/components/shared/DynamicsEnvironmentToggle';
import { ErpIntegrationSettings } from '@/components/shared/ErpIntegrationSettings';
import { canOverrideDynamicsEnvironment } from '@/lib/dynamicsEnvironment';
import { canChangeErpIntegrationSettings } from '@/lib/erpIntegrationSettings';

export default function SessionSettings() {
  if (!canOverrideDynamicsEnvironment) {
    return <Navigate to="/customer-portal" replace />;
  }

  return (
    <Layout title="Configurações da Sessão">
      <Card>
        <CardHeader className="pb-4">
          <div className="flex items-center gap-2">
            <Settings className="h-5 w-5 text-muted-foreground" />
            <CardTitle className="text-lg">Configurações da Sessão</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <DynamicsEnvironmentToggle />
          {canChangeErpIntegrationSettings && <ErpIntegrationSettings />}
        </CardContent>
      </Card>
    </Layout>
  );
}
